import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import z from 'zod'

import { itemMasterApi } from '@/features/inventory/api/item-master-api'
import { productApi } from '@/features/product/api/product-api'
import { RecipeFormPage } from '@/features/recipe/components/recipe-form-page'
import { RecipeRefType } from '@/features/recipe/recipe-dto'

const searchParams = z.object({
  refId: z.string().describe('Product or Item ID'),
  refType: RecipeRefType,
})

export const Route = createFileRoute('/_app/inventory/recipe/')({
  validateSearch: zodValidator(searchParams),
  loaderDeps: ({ search }) => search,
  loader: async ({ deps, context }) => {
    const { refId, refType } = deps

    if (!refId) throw new Error('Missing refId')
    if (!refType) throw new Error('Missing refType')

    // if (refType === 'item')
    //   await context.qc.ensureQueryData(itemMasterApi.detail.query({ params: { id: refId } }))
    // else await context.qc.ensureQueryData(productApi.detail.query({ params: { id: refId } }))
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <RecipeFormPage />
}
